export const MAX_PARTNERS_RESULTS = 50;
